export interface Errorable {
  getHasErrorOccurred(): boolean;
  setHasErrorOccurred(errorOccurred: boolean): void;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const isErrorable = (value: any): value is Errorable =>
  'getHasErrorOccurred' in value;
